exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".example-fill-remaining-space {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n}\n\n\n.example-spacer {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n}\n\n.example-container {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n\nbody {\n  margin: 0;\n  font-family: Roboto, sans-serif;\n}\n\nmat-card {\n  max-width: 90%;\n  margin: 2em auto;\n  text-align: center;\n}\n\nmat-toolbar-row {\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n\n.done {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  color: white;\n}\n\n.user-avatar {\n  border-radius: 99%;\n  width: 32px;\n  height: 32px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/neerajvyas/Documents/pointtoshare/p2sfirebase2/PointToShare/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main